/**
 * LLM Model Constants
 *
 * Available LLM models grouped by provider for session summarization.
 * Platform default is gemini-2.5-flash-lite for cost optimization and low latency.
 */

export const LLM_MODELS = {
  GOOGLE: [
    { value: 'gemini-2.5-flash-lite', label: 'Gemini 2.5 Flash Lite (Platform Default) · 1M ctx' },
    { value: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash · 1M ctx' },
    { value: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro · 1M ctx' },
    { value: 'gemini-4-argon', label: 'Gemini 4 Argon · 1M ctx' },
    { value: 'gemini-2.0-flash', label: 'Gemini 2.0 Flash · 1M ctx' },
  ],
  ANTHROPIC: [
    { value: 'claude-sonnet-4-5-20250929', label: 'Claude Sonnet 4.5 · 200K ctx' },
    { value: 'claude-sonnet-4-6', label: 'Claude Sonnet 4.6 · 1M ctx' },
    { value: 'claude-opus-4-6', label: 'Claude Opus 4.6 · 1M ctx' },
    { value: 'claude-haiku-4-5-20251001', label: 'Claude Haiku 4.5 (Fast) · 200K ctx' },
  ],
  OPENAI: [
    { value: 'gpt-5.1', label: 'GPT-5.1 · 128K ctx' },
    { value: 'gpt-5-mini', label: 'GPT-5 Mini · 400K ctx' },
    { value: 'gpt-4o', label: 'GPT-4o · 128K ctx' },
    { value: 'gpt-4o-mini', label: 'GPT-4o Mini · 128K ctx' },
    { value: 'o3', label: 'o3 (Reasoning) · 200K ctx' },
    { value: 'o4-mini', label: 'o4-mini (Reasoning) · 200K ctx' },
  ],
};

export const DEFAULT_LLM_MODEL = 'gemini-2.5-flash-lite';

export const REASONING_LEVELS = [
  { value: 'none', label: 'None' },
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const DEFAULT_REASONING_LEVEL = 'medium';

/**
 * Get all models as a flat array for dropdown options
 */
export const getAllModels = () => {
  return [
    ...LLM_MODELS.GOOGLE,
    ...LLM_MODELS.ANTHROPIC,
    ...LLM_MODELS.OPENAI,
  ];
};

/**
 * Get grouped models for optgroup rendering
 */
export const getGroupedModels = () => {
  return [
    { label: 'Google', options: LLM_MODELS.GOOGLE },
    { label: 'Anthropic', options: LLM_MODELS.ANTHROPIC },
    { label: 'OpenAI', options: LLM_MODELS.OPENAI },
  ];
};
